import styled from 'styled-components';

export const Divider = styled.hr`
  height: 1px;
  width: 100%;
  background-color: #71b9ca;
  border-width: 0;
`;
